import {Link} from 'react-router';
import {groupBy} from 'lodash';
import {Button, Modal} from '@goproblems/ui';

import {hideModal, useSelector} from '@utils';
import {MODAL_PROBLEM_FLAGS_OWNER} from '@utils';
import {useTranslation} from 'react-i18next';
import {Loading, ProblemFlagBadge, ProblemFlagsTable} from '@components';
import {useFetchProblemFlagsQuery} from '@api';
import {isMobile} from 'react-device-detect';

export const ProblemFlagsOwnerModal = ({
    problemId,
    name = MODAL_PROBLEM_FLAGS_OWNER,
    afterDelete,
}: {
    problemId: number;
    name?: string;
    afterDelete?: () => void;
}) => {
    const show = useSelector(s => s.modalProblemFlagsOwner);
    const {t} = useTranslation();
    const {
        data: flagsData,
        isLoading,
        refetch,
    } = useFetchProblemFlagsQuery(
        {problemId},
        {
            refetchOnMountOrArgChange: true,
            skip: !show,
        }
    );

    const handleClose = () => {
        hideModal(name);
    };

    const group = groupBy(flagsData?.entries, 'type');
    const badges = Object.entries(group).map(([key, value]) => (
        <ProblemFlagBadge key={key} type={key} number={value.length} />
    ));

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName={`max-w-fit ${isMobile ? '' : 'min-w-[768px]'}`}
                scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t('single_problem.problem_flags')}
                    </Modal.Title>
                    {
                        <Link
                            className="mt-2 ml-2 link text-xs"
                            to={`/problems/${problemId}/flaghist`}>
                            {t('single_problem.change_history')}
                        </Link>
                    }
                </Modal.Header>
                <Modal.Body>
                    <div className={'my-2'}>{badges}</div>
                    <div>
                        {isLoading && <Loading />}
                        {!isLoading && flagsData?.entries && (
                            <ProblemFlagsTable
                                problemOwner={true}
                                flags={flagsData.entries}
                                onDelete={() => {
                                    void refetch();
                                    if (afterDelete) afterDelete();
                                }}
                            />
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('common.close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
